export default {
    userInfo: {
        token: ''
    }
}